import styled from 'styled-components';
import { Modal } from 'antd';

export const ModalContainer = styled(Modal)`
  max-width: 900px;

  .ant-paragraph {
    width: 50%;
  }
  .ant-divider {
    font-size: 14px;
    margin-bottom: 24px;
  }

  .modal-tab > .ant-tabs-nav,
  .modal-edit .ant-tabs-nav {
    display: none;
  }
`;

export const SharedPlanContent = styled.div`
  width: 100%;
  padding: 16px;
  background: ${({ theme }) => theme.colors.background1};
  border-radius: ${({ theme }) => theme.shapes.borderRadius};
  border: 1px solid ${({ theme }) => theme.colors.border};

  .shared-plan-content-tags {
    margin-top: 16px;
    display: flex;
    flex: wrap;
  }
`;
